export default __webpack_public_path__ + "static/media/logo-sudan.51399803.png";